import { OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { EnvService } from '../env.service';
var FooterComponent = /** @class */ (function () {
    function FooterComponent(workspaceService, env) {
        this.workspaceService = workspaceService;
        this.env = env;
        this.showAppVersion = this.env.showAppVersion;
        this.footerText = this.env.footerText;
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.workspaceService.getAppVersion().subscribe(function (result) {
            _this.appVersion = result;
        });
    };
    return FooterComponent;
}());
export { FooterComponent };
